import React, { useContext } from 'react';
import { SiteContext } from '../../context/SiteContext';
import List from '../common/List';
import { useTranslation } from 'react-i18next';
import { CommonValidation } from '../common/CommonValidation/commonValidation';

type PageInfoCreatePlanProps = {
  showReasonsToProtect: boolean;
};

const PageInfoCreatePlan = ({
  showReasonsToProtect
}: PageInfoCreatePlanProps): JSX.Element => {
  const { site } = useContext(SiteContext);
  const cms = site.content;

  const { t } = useTranslation();

  const showJustSoYouKnow = CommonValidation.isNotEmpty(
    cms.productVariantPage.justSoYouKnow
  );

  return (
    <div className='info'>
      {showReasonsToProtect && (
        <div className='m05-bottom'>
          <List id='reasons-to-protect' list={cms.reasonsToProtect} />
        </div>
      )}
      {showJustSoYouKnow && (
        <div>
          {showReasonsToProtect && <hr />}

          <div className='m05-bottom'>
            <p className='p1-bold m05-bottom'>
              {t('page-info.just-so-you-know')}
            </p>
            <p className='p3 m05-bottom cms'>
              {cms.productVariantPage.justSoYouKnow}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
export default PageInfoCreatePlan;
